import { ProductTicketLotCriterion } from '../../../../../core/types/Tickets'

export const lotCriterionValues = Object.values(
  ProductTicketLotCriterion
).filter((v) => typeof v === 'number')

export const lotCriterionConfig = {
  [ProductTicketLotCriterion.quantity]: {
    name: 'quantity',
    description: 'Quantidade',
  },
  [ProductTicketLotCriterion.date]: {
    name: 'date',
    description: 'Data',
  },
  [ProductTicketLotCriterion.both]: {
    name: 'both',
    description: 'Ambos',
  },
}
